module.exports = __webpack_public_path__ + "static/media/down-arrow.c9471b79.svg";